import { useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const checkPOBudgetTypeQuery = async (payload) => {
  const response = await axios.post(apiurl?.checkPOBudgetType, payload);
  return response;
};

const checkPOBudgetType = () => {
  const { mutate, isLoading, data, isError, error, reset } = useMutation(
    ['checkPOBudgetType'],
    checkPOBudgetTypeQuery
  );

  return { mutate, isLoading, data, isError, error, reset };
};

export default checkPOBudgetType;
